import { useIsAgentThinking } from "@/hooks/use-is-agent-thinking";
import { AgentState } from "@livekit/components-react";
import { PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

type VoiceAgentStateCapsuleContainerProps = {
  agentState: AgentState;
} & PropsWithChildren;

export const VoiceAgentStateCapsuleContainer = ({
  children,
  agentState,
}: VoiceAgentStateCapsuleContainerProps) => {
  const isThinking = useIsAgentThinking(agentState);

  return (
    <div
      className={twMerge(
        "nut-bg-magic-gradient nut-w-[100%] nut-mb-[10px] nut-rounded-[1023px] nut-p-[1px] nut-flex nut-items-center nut-justify-center",
        isThinking ? "nut-animate-shadow-pulse" : "",
      )}
    >
      <div className="widget-content nut-cursor-pointer nut-w-[100%] nut-h-[52px] nut-rounded-[1023px] nut-bg-white nut-flex nut-items-center nut-justify-center nut-gap-[5px]">
        {children}
      </div>
    </div>
  );
};
